module.exports = __webpack_public_path__ + "static/media/logo118.b87dc2bc.png";